import authLoader from '../../routes/authLoader';
import { EditCustomerPage } from './components/EditCustomerInfo';
import ViewClientPage from './components/ViewClientPage';

export const customerRoutes = [
  {
    path: 'customer',
    element: <EditCustomerPage />,
    loader: authLoader,
  },
  {
    path: 'client',
    element: <ViewClientPage />,
    loader: authLoader,
  },
];
